import { FormValidationType, CUSTOM_VALIDATION_TYPES } from "../../../../types";
import { PRODUCT_INFORMATION_CONSTANTS } from "../../../constants";
import { GENERAL_FORM_CONSTANTS } from "../../../../constants";

export const formFieldsValidation: FormValidationType = {
  [PRODUCT_INFORMATION_CONSTANTS.COUNTRY_WHERE_ITEM_WAS_PURCHASED]: {
    required: { value: true },
  },
  [PRODUCT_INFORMATION_CONSTANTS.ORDER_ID]: {
    required: { value: true },
    [CUSTOM_VALIDATION_TYPES.ORDER_ID_FORMAT]: { value: true },
    matchRegExp: {
      value: new RegExp(GENERAL_FORM_CONSTANTS.ORDER_ID_REGEX),
      message: GENERAL_FORM_CONSTANTS.ORDER_ID_INVALID_MESSAGE,
    },
  },
  [PRODUCT_INFORMATION_CONSTANTS.ASIN]: {
    required: { value: true },
    changeToUpperCase: { value: true },
    matchRegExp: {
      value: new RegExp(GENERAL_FORM_CONSTANTS.ASIN_REGEX),
      message: GENERAL_FORM_CONSTANTS.ASIN_INVALID_MESSAGE,
    },
  },
  [PRODUCT_INFORMATION_CONSTANTS.PRODUCT_NAME]: {
    required: { value: true },
  },
  [PRODUCT_INFORMATION_CONSTANTS.FULFILMENT_PATH]: {
    required: { value: true },
  },
};
